export const LOGIN = 'loginAction';
export const REFRESH = 'refreshAction';
export const LOGOUT = 'logoutAction';
export const SWITCH_CONTRACT = 'switchContract';
export const GET_CONTRACTS = 'getContracts';

